import React from 'react'
import './Loader.scss'

const Loader = ({size}) => {
  return (
    <div className="container" style={{'--uib-size': size}}>
      <div className="slice"></div>
      <div className="slice"></div>
      <div className="slice"></div>
      <div className="slice"></div>
      <div className="slice"></div>
      <div className="slice"></div>
    </div>
  )
}

export default Loader